/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_FirstInputs */

const en_us2_body_measures_first = /** @type {(inputs: Body_Measures_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First reading`)
};

const pt_br2_body_measures_first = /** @type {(inputs: Body_Measures_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primeira medida`)
};

const es_419_body_measures_first = /** @type {(inputs: Body_Measures_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primera medida`)
};

const pt_pt2_body_measures_first = /** @type {(inputs: Body_Measures_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primeira medida`)
};

const fr_fr2_body_measures_first = /** @type {(inputs: Body_Measures_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Première mesure`)
};

const de_de2_body_measures_first = /** @type {(inputs: Body_Measures_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erste Messung`)
};

const it_it2_body_measures_first = /** @type {(inputs: Body_Measures_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prima misura`)
};

/**
* | output |
* | --- |
* | "First reading" |
*
* @param {Body_Measures_FirstInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_first = /** @type {((inputs?: Body_Measures_FirstInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_FirstInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_first(inputs)
	if (locale === "es-419") return es_419_body_measures_first(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_first(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_first(inputs)
	if (locale === "de-DE") return de_de2_body_measures_first(inputs)
	if (locale === "it-IT") return it_it2_body_measures_first(inputs)
	return en_us2_body_measures_first(inputs)
});
export { body_measures_first as "body-measures.first" }